<script setup>
const footerLinks = [
  {
    title: '合作',
    links: [
      { name: '招募合作', path: '/join' },
      { name: '关于水芯', path: '/about-us' }
    ]
  },
  {
    title: '法律声明',
    links: [
      { name: '服务条款', path: '/terms' },
      { name: '隐私政策', path: '/privacy' }
    ]
  }
]
</script>

<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="container footer-grid">
        <!-- Brand Info -->
        <div class="footer-col brand-col">
          <div class="footer-logo">
            <div class="logo-icon">
              <img src="@/assets/logo.png" alt="水芯" class="logo-img" />
            </div>
            <div class="logo-text">
              <span class="brand-cn">水芯</span>
            </div>
          </div>
          <ul class="brand-desc">
            <li>客户资源换长期销售收益</li>
            <li>样品测试推动真实成交</li>
            <li>回款后结算佣金提成</li>
          </ul>
        </div>

        <!-- Navigation Links -->
        <div v-for="section in footerLinks" :key="section.title" class="footer-col">
          <h4 class="col-title">{{ section.title }}</h4>
          <ul class="link-list">
            <li v-for="link in section.links" :key="link.name">
              <router-link v-if="link.path.startsWith('/')" :to="link.path" class="footer-link">
                {{ link.name }}
              </router-link>
              <a v-else href="#" class="footer-link">{{ link.name }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact Us Section -->
        <div class="footer-col contact-col">
          <h4 class="col-title">联系我们</h4>
          <div class="qr-group">
            <div class="qr-item">
              <div class="qr-wrapper">
                <img src="@/assets/images/shipinhao.png" alt="视频号" class="footer-qr" />
              </div>
              <span class="qr-label">视频号</span>
            </div>
            <div class="qr-item">
              <div class="qr-wrapper">
                <img src="@/assets/images/weixin.png" alt="公众号" class="footer-qr" />
              </div>
              <span class="qr-label">公众号</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container footer-bottom-content">
        <div class="copyright">
          <span>&copy; 2025 水芯. 版权所有</span>
        </div>
        <div class="beian">
          <span class="beian-separator">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
            粤ICP备2025423372号
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background-color: #0f141a;
  color: #ffffff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.footer-top {
  padding: 80px 0 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  gap: 60px;
}

/* Brand Column */
.brand-col {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 44px;
  height: 44px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
}

.logo-text {
  display: flex;
  flex-direction: column;
}

.brand-en {
  font-size: 12px;
  color: #94a3b8;
  letter-spacing: 1px;
  margin-top: 2px;
}

.brand-cn {
  font-weight: 700;
  font-size: 18px;
  line-height: 1.1;
  color: #ffffff;
  letter-spacing: 1px;
}

.brand-desc {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
  max-width: 320px;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.brand-desc li::before {
  content: '·';
  color: #005eb8;
  font-weight: 700;
  margin-right: 8px;
}

/* Column Titles */
.col-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #ffffff;
  position: relative;
  padding-bottom: 12px;
}

.col-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 24px;
  height: 2px;
  background-color: #005eb8;
}

/* Link Lists */
.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  margin-bottom: 12px;
}

.footer-link {
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.2s ease;
  display: inline-block;
}

.footer-link:hover {
  color: #ffffff;
  transform: translateX(4px);
}

/* Contact/QR Section */
.qr-group {
  display: flex;
  gap: 32px;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qr-wrapper {
  background: #ffffff;
  padding: 6px;
  border-radius: 10px;
  transition: transform 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.qr-wrapper:hover {
  transform: translateY(-5px);
}

.footer-qr {
  width: 100px;
  height: 100px;
  display: block;
}

.qr-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

/* Footer Bottom */
.footer-bottom {
  background-color: #0c1015;
  padding: 30px 0;
  color: #64748b;
  font-size: 13px;
}

.footer-bottom-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.beian-separator {
  color: #334155;
  margin-right: 16px;
}

.beian-link {
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s;
}

.beian-link:hover {
  color: #ffffff;
}

/* Responsive */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}

@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .col-title::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .footer-logo, .qr-group {
    justify-content: center;
  }
  
  .brand-desc {
    margin: 0 auto;
  }
}
</style>
